import axios from "axios";
import useAppSelector from "hooks/useAppSelector";
import { IMxpAvailabilitySlot } from "interfaces/MXP/IMxpAvailabilitySlot";
import { useQuery } from "@tanstack/react-query";
import { getDinningUrl } from "config/configUtils";
import { useCheckFeatureFlags } from "hooks/common/featureFlags/useCheckFeatureFlags";

export const useGetDiningCart = () => {
  const { isMxpEnabled } = useCheckFeatureFlags();

  const sessionId = useAppSelector((state) => state.authentication.sessionId);
  const URL = `${getDinningUrl()}/api/dining/carts`;

  const { refetch, status, data, error, isFetching, isSuccess } = useQuery({
    queryKey: ["getDiningCart"],
    queryFn: async () =>
      await axios
        .get(URL, {
          headers: {
            SessionId: sessionId,
          },
        })
        .then((res) => res.data as Promise<IMxpAvailabilitySlot[]>),
    refetchOnWindowFocus: false,
    enabled: !!isMxpEnabled,
    retry: 1,
  });

  return {
    getDiningCart: refetch,
    data: data ?? [],
    status,
    error,
    isFetching,
    isSuccess,
  };
};
